import { useEffect, useState } from "react";
import { useWeb3React } from "@web3-react/core";
import { ApolloQueryResult, gql } from "@apollo/client";
import { useChainId } from "../../../../lib/chains";
import { getGmxGraphClient } from "../../../../lib/subgraph";
import { bigNumberify } from "../../../../lib/numbers";
import { BigNumber } from "ethers";

type ExpiredRewardItem = {
  index: number;
  tier: number;
  rewardAmount: BigNumber | undefined;
  claimedRewardAmount: BigNumber | undefined;
  expiredRewardAmount: BigNumber | undefined;
};

type ScheduleInfo = {
  allocated: string;
  claimed: string;
  destroyed: string;
  index: number;
  isDestroyed: boolean;
  tier: number;
};

type VestingInfo = {
  scheduleInfo: ScheduleInfo[];
};

export const useExpiredRewards = (): ExpiredRewardItem[] => {
  const { account } = useWeb3React();
  const [res, setRes] = useState<ApolloQueryResult<{ vestInfo: VestingInfo }>>();
  const { chainId } = useChainId();

  const query = gql(`
    query vestingExpiredInfoByUser($account: String!) {
      vestInfo(id: $account) {
        scheduleInfo {
          allocated
          claimed
          destroyed
          index
          isDestroyed
          tier
        }
      }
    }`);
  useEffect(() => {
    const watch = getGmxGraphClient(chainId)
      ?.watchQuery({
        query,
        variables: { account: (account || "").toLowerCase() },
        pollInterval: 10 * 1000,
        fetchPolicy: "network-only",
      })
      .subscribe(
        setRes,
        // eslint-disable-next-line no-console
        console.warn
      );
    return () => {
      watch?.unsubscribe();
    };
  }, [setRes, query, chainId, account]);

  if (!res?.data.vestInfo) {
    return [];
  }

  return res.data.vestInfo.scheduleInfo
    .filter((i) => i.isDestroyed)
    .map((rewardItem, index): ExpiredRewardItem => {
      return {
        index,
        tier: rewardItem.tier,
        rewardAmount: bigNumberify(rewardItem.allocated),
        claimedRewardAmount: bigNumberify(rewardItem.claimed),
        expiredRewardAmount: bigNumberify(rewardItem.destroyed),
      };
    });
};
